var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1518,
    height: 1518,
    viewBox: "0 0 1518 1518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1517.14V1517.14H0V0Z",
    fill: "#FFEA74"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_760_213)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_760_213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -92,
    y: -36,
    width: 5093,
    height: 6922
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5000.58 -35.3633H-91.127V6885.34H5000.58V-35.3633Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_760_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336 332.093H622.171V1186.01H336V332.093ZM443.694 1161.48H705.524C749.83 1161.48 785.781 1152.91 813.379 1135.76C839.079 1120.68 859.793 1098.39 872.951 1071.64C884.631 1047.87 891.204 1021.9 892.248 995.429C893.771 970.152 889.442 944.865 879.597 921.538C871.89 903.711 860.062 887.972 845.087 875.616C827.447 862.146 808.938 849.857 789.678 838.831C774.84 830.853 760.555 821.883 746.921 811.984C736.255 804.011 727.229 794.051 720.337 782.652C712.861 769.427 709.15 754.403 709.608 739.215C709.06 722.741 713.138 706.443 721.378 692.171C731.614 676.568 743.624 662.206 757.169 649.375C775.686 630.886 791.825 610.156 805.212 587.666C816.421 568.111 822.747 541.264 824.429 507.043C826.405 480.511 822.777 453.86 813.779 428.825C806.054 407.298 791.841 388.704 773.103 375.61C753.193 362.526 729.73 355.92 705.925 356.697H465.714V332.093H739.394C797.119 331.366 854.82 334.902 912.025 342.672C960.322 349.084 1006.71 365.663 1048.14 391.318C1067.41 402.994 1083.44 419.313 1094.79 438.785C1106.13 458.258 1112.42 480.265 1113.08 502.796C1115.7 548.797 1103.05 585.208 1075.13 612.029C1046.88 639.038 1012.59 658.903 975.121 669.972C928.862 683.492 881.828 694.197 834.277 702.029C796.884 709.161 770.862 715.012 756.209 719.42C741.556 723.827 734.269 730.399 734.269 738.974C734.269 751.37 743.824 759.678 762.935 763.898C794.356 769.745 826.091 773.759 857.978 775.92C912.008 780.014 965.714 787.617 1018.76 798.68C1061.6 807.83 1101.24 828.246 1133.58 857.825C1166.09 887.584 1181.89 930.995 1180.98 988.056C1180.07 1045.12 1156.4 1087.86 1109.96 1116.28C1060.48 1146.41 1005.2 1165.75 947.737 1173.02C877.364 1182.23 806.44 1186.57 735.47 1186.01H443.694V1161.48Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_760_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 946,
    height: 956,
    fill: "white",
    transform: "translate(286 281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewlogo);
export default __webpack_public_path__ + "static/media/newlogo.34a38fe4259c3531de95b7b4f35101df.svg";
export { ForwardRef as ReactComponent };